/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */

import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
  TextareaProps
} from "@chakra-ui/react";
import { FieldError, FieldValues, Path, UseFormRegister } from "react-hook-form";
import { IconType } from "react-icons";
import { TextGray } from "../../Texts/TextGray";

interface Props<T extends FieldValues> extends TextareaProps {
  name: Path<T>;
  label?: string;
  icon?: IconType;
  error?: FieldError;
  register: UseFormRegister<T>;
}

export const InputTextArea = <T extends FieldValues>({
  name,
  label,
  error,
  register,
  icon: IconComponent,
  ...props
}: Props<T>) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name} fontSize="sm">
          <Flex alignItems="center">
            {IconComponent && (
              <TextGray as="span" mr="1.5">
                <IconComponent />
              </TextGray>
            )}
            {label}
          </Flex>
        </FormLabel>
      )}
      <Textarea id={name} {...register(name)} {...props} />
      {!!error && (
        <FormErrorMessage mt="1" fontSize="xs">
          {error.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};
